// extracted by mini-css-extract-plugin
export default {"hidden":"qveoZD0fNjpHOPScTDpA","visible":"V9sUFvWmwHmQjdyegr6L"};